<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-0">
        <v-layout wrap>
            <v-flex xs12>
                <v-card
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-layout row justify-space-between>
                        <v-layout column class="ma-1 px-3">
                            <v-card-text
                                class="mb-0 pb-0 pt-3 pl-2"
                                v-if="student && student.familyID"
                            >
                                <div
                                    class="display-1 font-weight-bold mb-0 ml-0"
                                >
                                    {{
                                        student.hebName +
                                            " " +
                                            student.lastNameH
                                    }}
                                </div>
                                <div class="ml-0 mt-4">
                                    <div class="pl-3">
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Family ID:
                                            </div>
                                            <div>
                                                {{ student.familyID }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Student ID:
                                            </div>
                                            <div>
                                                {{ student.studentID }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Father:
                                            </div>
                                            <div>
                                                {{ student.fatherH }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Branch:
                                            </div>
                                            <div>
                                                {{ student.branch }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Grade:
                                            </div>
                                            <div>
                                                {{ student.class }}
                                            </div>
                                        </v-layout>

                                        <div style="" class="mt-2">
                                            <v-layout
                                                style="width: 250px"
                                                row
                                                class="my-2"
                                                v-for="phone in phonesNumbers"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    {{
                                                        getPhoneType(
                                                            phone.phoneType
                                                        )
                                                    }}:
                                                </div>
                                                <div>
                                                    {{ phone.phoneNum }}
                                                </div>
                                            </v-layout>
                                        </div>

                                        <v-divider class="pb-2"></v-divider>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Registered:
                                            </div>
                                            <div>
                                                {{
                                                    student.isCampRegistered
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Pin:
                                            </div>
                                            <div>
                                                {{ student.pin }}
                                            </div>
                                        </v-layout>
                                    </div>
                                    <v-layout row class="pa-0 ma-0">
                                        <div
                                            style="border: 2px solid #4caf50; width: 60%"
                                            class="pa-3 my-2"
                                        >
                                            <v-layout
                                                row
                                                justify-space-between
                                                class="pl-3 pt-1 pb-0"
                                                v-if="
                                                    student && student.familyID
                                                "
                                            >
                                                <div class="pt-2">
                                                    <v-layout row class="mb-2">
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Available Minutes:
                                                        </div>
                                                        <div>
                                                            {{
                                                                student.availableMinutes
                                                            }}
                                                        </div>
                                                    </v-layout>
                                                    <v-layout row class="mb-2">
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Minutes:
                                                        </div>
                                                        <div>
                                                            {{
                                                                student.minutes
                                                            }}
                                                        </div>
                                                    </v-layout>
                                                    <v-layout row class="mb-2">
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Added Minutes:
                                                        </div>
                                                        <div>
                                                            {{
                                                                student.addedMinutes
                                                            }}
                                                        </div>
                                                    </v-layout>
                                                    <v-layout row class="mb-0">
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Minutes Used:
                                                        </div>
                                                        <div>
                                                            {{
                                                                student.minutesUsed
                                                            }}
                                                        </div>
                                                    </v-layout>
                                                </div>

                                                <div class="pt-2">
                                                    <v-layout
                                                        row
                                                        class="mb-2"
                                                        v-if="student.note"
                                                    >
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Note:
                                                        </div>
                                                        <div>
                                                            {{ student.note }}
                                                        </div>
                                                    </v-layout>
                                                    <v-layout
                                                        row
                                                        class="mb-2"
                                                        v-if="student.updatedBy"
                                                    >
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Updated By:
                                                        </div>
                                                        <div>
                                                            {{
                                                                student.updatedBy
                                                            }}
                                                        </div>
                                                    </v-layout>
                                                    <v-layout
                                                        row
                                                        class="mb-2"
                                                        v-if="student.updatedAt"
                                                    >
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Updated At:
                                                        </div>
                                                        <div>
                                                            {{
                                                                student.updatedAt
                                                                    | time
                                                            }}
                                                        </div>
                                                    </v-layout>
                                                </div>

                                                <v-btn
                                                    small
                                                    color="success"
                                                    style="height: 28px;"
                                                    class="mr-1 my-0"
                                                    @click="openMinutesDialog"
                                                    >Adjust Minutes</v-btn
                                                >
                                            </v-layout>
                                        </div>
                                        <div
                                            style="border: 2px solid #4caf50; width: 40%"
                                            class="pa-3 my-2 mx-2"
                                            v-if="
                                                student &&
                                                    student.branch == 'MK'
                                            "
                                        >
                                            <v-layout
                                                row
                                                justify-space-between
                                                class="pl-3 pt-1 pb-0"
                                            >
                                                <div class="pt-3">
                                                    <!-- <div class="headline">
                                                        MK Information
                                                    </div> -->
                                                    <v-layout row class="mb-2">
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Status:
                                                        </div>
                                                        <div>
                                                            {{
                                                                student.mkStatus
                                                            }}
                                                        </div>
                                                    </v-layout>
                                                    <v-layout row class="mb-2">
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Bus Stop:
                                                        </div>
                                                        <div>
                                                            {{
                                                                student.mkBusStop
                                                            }}
                                                        </div>
                                                    </v-layout>
                                                    <v-layout row class="mb-0">
                                                        <div
                                                            class="font-weight-medium mr-2 width-150"
                                                        >
                                                            Bus Time:
                                                        </div>
                                                        <div>
                                                            {{
                                                                student.mkBusTime
                                                            }}
                                                        </div>
                                                    </v-layout>
                                                </div>

                                                <v-btn
                                                    small
                                                    color="success"
                                                    style="height: 28px;"
                                                    class="mr-1 my-0"
                                                    @click="openMkInfoDialog"
                                                    >Edit</v-btn
                                                >
                                            </v-layout>
                                        </div>
                                    </v-layout>
                                </div>
                            </v-card-text>
                        </v-layout>
                    </v-layout>

                    <v-spacer></v-spacer>

                    <!-- <v-layout
                        align-end
                        justify-space-between
                        column
                        fill-height
                        class="mb-0 mr-2"
                    >
                        <v-btn
                            class="mt-0 mb-3 mr-1"
                            color="success"
                            small
                            dark
                            @click="openEditDialog"
                        >
                            Edit
                        </v-btn>
                    </v-layout> -->
                </v-card>

                <v-card
                    class="pa-3 mt-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-tabs color="success" dark icons-and-text>
                        <v-tabs-slider color="#fff"></v-tabs-slider>

                        <v-tab href="#calls">
                            Calls ({{ getTotalCallsCount() }})
                            <v-icon>mdi-phone</v-icon>
                        </v-tab>

                        <v-tab href="#voicemails">
                            Voicemails ({{ getVoicemailCount() }})
                            <v-icon>mdi-voicemail</v-icon>
                        </v-tab>

                        <v-tab href="#filter">
                            Filter ({{ getFilterCount() }})
                            <v-icon>mdi-lock</v-icon>
                        </v-tab>
                        <v-tab-item value="calls">
                            <camp-student-calls
                                v-if="student && student.studentID"
                                :studentID="student.studentID"
                                ref="callsList"
                            ></camp-student-calls>
                        </v-tab-item>
                        <v-tab-item value="voicemails">
                            <camp-voicemails
                                v-if="student && student.studentID"
                                :studentID="student.studentID"
                                ref="voicemailList"
                            ></camp-voicemails>
                        </v-tab-item>
                        <v-tab-item value="filter">
                            <camp-filter-list
                                v-if="student && student.studentID"
                                :studentID="student.studentID"
                                :student="student"
                                ref="filterList"
                            ></camp-filter-list>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog persistent v-model="minutesDialog" max-width="400">
            <v-card class="pa-2" v-if="student && student.familyID">
                <v-card-title class="headline pt-2"
                    >Adjust Minutes</v-card-title
                >
                <v-text-field
                    class="px-3"
                    v-model="minutes.addedMinutes"
                    label="Adjusted Minutes"
                    type="number"
                ></v-text-field>
                <v-text-field
                    class="px-3 mb-3"
                    v-model="minutes.note"
                    label="Note"
                    hide-details
                ></v-text-field>
                <v-layout row justify-space-between class="px-3 my-2">
                    <div class="font-weight-medium">
                        Minutes:
                    </div>
                    <div>{{ student.minutes }}</div>
                </v-layout>
                <v-layout row justify-space-between class="px-3 my-2">
                    <div class="font-weight-medium">
                        Available:
                    </div>
                    <div>{{ getAvailableMinutes() }}</div>
                </v-layout>
                <v-card-actions class="">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="minutesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="saveMinutes"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="mkInfoDialog" max-width="400">
            <v-card class="pa-2" v-if="student && student.familyID">
                <v-card-title class="headline pt-2"
                    >Update MK Info</v-card-title
                >
                <v-text-field
                    class="px-3"
                    v-model="mkInfo.status"
                    label="Status"
                ></v-text-field>
                <v-text-field
                    class="px-3"
                    v-model="mkInfo.busStop"
                    label="Bus Stop"
                ></v-text-field>
                <!-- <v-text-field
                    class="px-3"
                    v-model="mkInfo.busTime"
                    label="Bus Time"
                ></v-text-field> -->
                <v-menu
                    ref="timeMenu"
                    v-model="mkInfo.timeMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="mkInfo.busTime"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="mkInfo.busTime"
                            label="Bus Time"
                            class="px-3"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-time-picker
                        v-if="mkInfo.timeMenu"
                        v-model="mkInfo.busTime"
                        full-width
                        @click:minute="$refs.timeMenu.save(mkInfo.busTime)"
                    ></v-time-picker>
                </v-menu>
                <v-card-actions class="">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="mkInfoDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="saveMkInfo"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { groupBy, formatPhoneNumber } from "../../utils/helpers.js";
import moment from "moment";
import campStudentCalls from "./CampStudentCalls.vue";
import campVoicemails from "./CampVoicmails.vue";
import campFilterList from "./CampFilterList.vue";

export default {
    components: {
        campStudentCalls,
        campVoicemails,
        campFilterList,
    },
    data: () => ({
        student: null,
        processing: false,
        loadingStudent: true,
        loadingFilter: true,
        filterList: [],
        phonesNumbers: [],
        minutesDialog: false,
        mkInfoDialog: false,
        activeTab: "calls",

        minutes: {
            addedMinutes: "",
            note: "",
        },

        mkInfo: {
            status: "",
            busStop: "",
            busTime: "",
            timeMenu: false,
        },

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },
    }),
    async created() {
        await this.load();
    },
    methods: {
        async load() {
            await this.loadStudent();
            this.loadAccountPhones();
        },
        async loadStudent() {
            const student = await this.$http.get(
                "api/campStudents/getStudent?studentID=" + this.$route.params.id
            );

            this.student = student;
            this.loadingStudent = false;
        },
        async loadAccountPhones() {
            const phones = await this.$http.get(
                "api/accounts/getAccountPhones?accountID=" +
                    this.student.familyID
            );

            this.phonesNumbers = phones;
        },
        getPhoneType(phoneType) {
            switch (phoneType) {
                case "PHON":
                    return "Home Phone";
                case "CEL":
                    return "Cellphone";
                case "MCEL":
                    return "Mother Cellphone";
            }
        },
        getTotalCallsCount() {
            if (!this.$refs.callsList) return 0;

            return this.$refs.callsList.getTotalCount();
        },
        getVoicemailCount() {
            if (!this.$refs.voicemailList) return 0;

            return this.$refs.voicemailList.getVoicemailCount();
        },
        getFilterCount() {
            if (!this.$refs.filterList) return 0;

            return this.$refs.filterList.getListCount();
        },
        openMkInfoDialog() {
            this.minutes.addedMinutes = this.student.addedMinutes;
            this.minutes.note = this.student.note;
            this.mkInfo.status = this.student.mkStatus;
            this.mkInfo.busStop = this.student.mkBusStop;
            this.mkInfo.busTime = this.student.mkBusTime;

            this.mkInfoDialog = true;
        },
        openEditDialog() {},
        openMinutesDialog() {
            this.minutes.addedMinutes = this.student.addedMinutes;
            this.minutes.note = this.student.note;

            this.minutesDialog = true;
        },
        getAvailableMinutes() {
            return +(
                +this.student.minutes +
                +this.minutes.addedMinutes -
                +this.student.minutesUsed
            ).toFixed(2);
        },
        async saveMinutes() {
            try {
                this.processing = true;

                await this.$http.post("api/campStudents/saveSettings", {
                    addedMinutes: +this.minutes.addedMinutes,
                    note: this.minutes.note,
                    user: this.$store.state.authentication.user,
                    studentID: this.student.studentID,
                });

                this.processing = false;
                this.minutesDialog = false;

                this.load();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveMkInfo() {
            try {
                this.processing = true;

                await this.$http.post("api/campStudents/saveSettings", {
                    addedMinutes: +this.minutes.addedMinutes,
                    note: this.minutes.note,
                    mkStatus: this.mkInfo.status,
                    mkBusStop: this.mkInfo.busStop,
                    mkBusTime: this.mkInfo.busTime,
                    user: this.$store.state.authentication.user,
                    studentID: this.student.studentID,
                });

                this.processing = false;
                this.mkInfoDialog = false;

                this.load();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.website-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
.distribution-list {
    border: 1px solid #ddd !important;
}
</style>
